<template>
  <div class="p-10 mb-10 bg-mimer-gray flex flex-col items-center text-sm md:text-base">
    <p class="font-bold text-center flex items-center justify-center">
      <svg
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          style="enable-background: new 0 0 512 512"
          xml:space="preserve"
      >
        <g>
          <path
              d="M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z"
              fill="#000000"
          />
          <path
              d="M12,5a1,1,0,0,0-1,1v8a1,1,0,0,0,2,0V6A1,1,0,0,0,12,5Z"
              fill="#000000"
          />
          <rect
              x="11"
              y="17"
              width="2"
              height="2"
              rx="1"
              fill="#000000"
          />
        </g>
      </svg>
      <!-- Text -->
      <span class="ml-2">Du kan inte anmäla intresse på lägenheten</span>
    </p>
    <p class="text-center">
      Ni är för många för att få bo här enligt våra grundkrav.<br />
      Du behöver söka en lägenhet med fler rum.
    </p>
    <div class="text-center">
      <span>Läs våra</span>
      <a
          href="https://www.mimer.nu/hyra-och-bo/om-var-uthyrning/vara-grundkrav-for-att-hyra-bostad/"
          class="text-black"
      >
        grundkrav för att hyra lägenhet
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "VerifyApplicationError",
};
</script>
